import request from '@/api/request.js'

// 获取列表
export function QuestionDetailGetRandomList(data) {
    return request({
        url: '/api/question/getquestiondetailrandomlist',
        method: 'post',
        data: data
    })
}

// 新增
export function QuestionDetailInsert(data) {
    return request({
        url: '/api/question/questiondetailinsert',
        method: 'post',
        data: data
    })
}

// 新增
export function QuestionDetailInsertMany(data) {
    return request({
        url: '/api/question/questiondetailinsertmany',
        method: 'post',
        data: data
    })
}

// 删除
export function QuestionDetailDelete(id) {
    return request({
        url: `/api/question/questiondetaildelete/${id}`,
        method: 'post',
        data: {}
    })
}

// 更新
export function QuestionDetailUpdate(id, data) {
    return request({
        url: `/api/question/questiondetailupdate/${id}`,
        method: 'post',
        data: data
    })
}

// 获取
export function QuestionDetailGetById(id) {
    return request({
        url: `/api/question/getquestiondetailbyid/${id}`,
        method: 'get',
        data: {}
    })
}

// 获取列表
export function QuestionDetailGetList(params) {
    return request({
        url: '/api/question/getquestiondetaillist',
        method: 'get',
        params: params
    })
}

// 获取分页列表
export function QuestionDetailGetPageList(params) {
    return request({
        url: '/api/question/getquestiondetailpagelist',
        method: 'get',
        params: params
    })
}